<script lang="ts" setup>
import BtnAccess from '@components/ui/footer/actions/BtnAccess.vue'
import BtnBack from '@components/ui/footer/actions/BtnBack.vue'
import FooterAttract from '@components/ui/footer/FooterAttract.vue'
import FooterUserCard from '@components/ui/footer/FooterUserCard.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()

const routeName = computed(() => route.name)
</script>

<template>
  <main class="flex flex-col">
    <div class="flex-1">
      <slot></slot>
    </div>
    <FooterAttract>
      <template #identification>
        <div
          class="bg-adk-main flex h-[calc(400*var(--vh))] w-[31.11vw] flex-col justify-center self-end rounded-t-xl"
        >
          <FooterUserCard />
        </div>
      </template>

      <template #primary-actions>
        <div class="w-full">
          <BtnAccess />
        </div>
      </template>

      <template #secondary-actions>
        <div class="min-h-[calc(80*var(--vh))] w-full">
          <!-- In future change lang + accessibility buttons will be here -->

          <template v-if="routeName === 'identification'">
            <BtnBack class="w-full" size="large" />
          </template>
        </div>
      </template>
    </FooterAttract>
  </main>
</template>
